module.exports = __webpack_public_path__ + "static/img/ranqi.183c21e0.png";